<template>
  <v-container grid-list-md>
    <h2 class="text-h6 mt-0 mb-3">Detalhes da Opção de Ação</h2>
    <v-card :loading="loading">
      <v-card-text>
        <h1 class="mb-3 text-h6">{{shareoption.assetDescription}} {{shareoption.ticker}}</h1>
        <p>Ticker: {{shareoption.ticker}}</p>
        <p>Company Ticker: {{shareoption.companyTicker}}</p>
        <p>ISIN: {{shareoption.isin}}</p>
        <p>Start Date: {{shareoption.tradingStartDate}}</p>
        <v-divider></v-divider>
        <apexchart width="100%" height="400" type="area" :options="options" :series="series"></apexchart>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import pt from 'apexcharts/dist/locales/pt-br.json';
import api from '@/services/api';

export default {
  data() {
    return {
      shareoption: {},
      loading: false,
      history: [],
      series: [],
      headers: [
        { text: 'Data', value: 'date' },
        { text: 'Variação', value: 'change' },
        { text: 'Preço Fechamento', value: 'close' },
        { text: 'Max', value: 'maximumPrice' },
        { text: 'Min', value: 'minimumPrice' },
      ],
      options: {
        chart: {
          locales: [pt],
          defaultLocale: 'pt-br',
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          zoom: {
            type: 'x',
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          line: {
            curve: 'smooth',
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: 'full',
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
          // opacityFrom: 0.5,
          // opacityTo: 0,
          // stops: [0, 90, 100],
          },
        },
        stroke: {
          show: true,
          curve: 'straight',
          // lineCap: 'butt',
          // colors: undefined,
          width: 2,
        },
        yaxis: {

          title: {
            text: '',
          },
          labels: {
            formatter: (val) => parseFloat(val).toFixed(0),
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeFormatter: {
              year: 'MM/yyyy',
              month: 'MM/yyyy',
              day: 'dd/MM/yyyy',
              hour: 'HH:mm',
            },
          },
        },
        tooltip: {
          shared: true,
          x: {
            show: true,
            format: 'dd/MM/yyyy',
            // format: 'dd/MM/yyyy HH:mm',
            formatter: undefined,
          },
          y: {
            formatter(val) {
              return `${val.toFixed(2)}`;
            },
          },
        },
      },
    };
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    async getData(date) {
      this.loading = true;
      this.id = this.$route.params.id;
      const { data: { shareOption } } = await api.shareoptions.getById(this.id, {
        params: {
          date,
        },
      });

      this.shareoption = shareOption;

      // Get Fund history information
      this.history = [];
      this.series = [];
      const {
        data: { history },
      } = await api.shareoptions.historyById(this.id, {
        params: {
          endDate: this.endDate,
          startDate: this.startDate,
        },
      });

      history.sort((a, b) => new Date(b.date) - new Date(a.date));

      this.history = history;

      // {
      //     data: fundData,
      //     name: 'Fundo',
      // },
      const seriesBuild = [];
      this.history.forEach((hist) => {
        seriesBuild.push({
          x: hist.date,
          y: Number(hist.exercisePrice.toString()),
        });
      });

      this.series = [{
        data: seriesBuild,
        name: 'Histórico',
      }];

      this.loading = false;
    },
  },
};
</script>
